module.exports = __webpack_public_path__ + "img/PENDING.04b4cffd.svg";